import type { Node } from '@tiptap/pm/model';

/** Copy the report's structure as text, including list markers that getText omits. */
export function reportPlainText(document: Node): string {
  function render(node: Node, indent = ''): string {
    const children: Node[] = [];
    node.forEach((child) => children.push(child));

    if (node.type.name === 'bulletList' || node.type.name === 'orderedList') {
      const start = Number(node.attrs.start ?? 1);
      return children.map((item, index) => {
        const marker = node.type.name === 'orderedList' ? `${start + index}. ` : '• ';
        const blocks: Node[] = [];
        item.forEach((child) => blocks.push(child));
        const continuation = indent + ' '.repeat(marker.length);
        return blocks.map((block, blockIndex) => {
          if (blockIndex === 0) {
            const lines = render(block).split('\n');
            return indent + marker + lines.join('\n' + continuation);
          }
          const nested = block.type.name === 'bulletList' || block.type.name === 'orderedList';
          return (nested ? '\n' : '\n\n') + render(block, nested ? indent + '  ' : continuation);
        }).join('');
      }).join('\n');
    }

    if (node.isTextblock) {
      const text = node.textBetween(0, node.content.size, '', (leaf) =>
        leaf.type.name === 'hardBreak' ? '\n' : (leaf.attrs.alt ?? ''),
      );
      return text.split('\n').map((line) => indent + line).join('\n');
    }

    return children.map((child) => render(child, indent)).join('\n\n');
  }

  return render(document);
}
